export const linksData = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "Exchanges",
    path: "/exchanges",
  },
  {
    title: "Dashboard",
    path: "/dashboard",
  },
];

export const chartDays = [
  {
    label: "24Hrs",
    value: 1,
  },
  {
    label: "30D",
    value: 30,
  },
  {
    label: "3M",
    value: 90,
  },
  {
    label: "1Yrs",
    value: 365,
  },
];
